import {openPanel} from '../sidePanel-action'

import './slideBottom.styl'

export function slideFromBottom(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-slideBottom' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelSlideFromBottom = slideFromBottom
